import request from 'api/request';

export default function createFollowupTicketRoute(id) {
  return request({ url: `/tickets/${id}/followup`, method: 'POST' });
}
